// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container {
  max-width: 600px;
  margin: 0px auto;
  border-radius: 6px;
  box-shadow: 0 0 41px 4px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  gap: 0rem;
}

.image-wrapper {
  position: relative;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  border-radius: 6px 6px 0 0;
}

.description-container {
  color: #fff;
  font-size: 18px;
  line-height: 25px;
  white-space: pre-wrap;
}

.description-editable {
  cursor: text;
  outline: 0;
  word-wrap: break-word;
  padding: 20px;
  border-radius: 0px 0px 5px 5px;
  min-height: 60px;
}

.description-editable:empty:before {
  content: attr(placeholder);
  color: #babec4;
  pointer-events: none;
}

/* PayPal header with toggle styles */
.paypal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.paypal-icon {
  margin-right: 8px;
  color: #003087;
}

.paypal-preview-container {
  border-width: 2px;
  font-size: 12px;
}

/* Image Preview Grid Layout */
.image-number-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 30px;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  z-index: 5;
}

.image-preview-section .card-container {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: transform 0.2s;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  max-width: none;
  margin: 0;
}

.image-preview-section .card-container:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.image-preview-section .image-wrapper {
  position: relative;
  overflow: hidden;
  flex: 1 1;
  min-height: 200px;
  background-color: #420120a7;
}

.image-preview-section .image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 0;
}

.image-preview-section .description-container {
  background-color: #000000;
  color: #ffffff;
}

/* Grid layout */
.grid-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
  width: 100%;
}

.grid-item {
  width: 100%;
}

/* Responsive grid */
@media (min-width: 576px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 768px) {
  .grid-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 992px) {
  .grid-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Sticky sidebar styles */
.sticky-sidebar {
  position: sticky;
  top: 80px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}

/* Set image preview to single column */
@media (min-width: 992px) {
  .image-preview-section .grid-container {
    grid-template-columns: repeat(1, 1fr);
  }
  
  .image-preview-section .card-container {
    max-width: 100%;
  }
  
  .image-preview-section .image-wrapper {
    min-height: 350px;
  }
}

/* Thumbnail click highlight effect */
.highlight-effect {
  box-shadow: 0 0 0 3px #4169e1 !important;
  transition: box-shadow 0.3s ease;
  border-radius: 6px;
}

/* Another approach: add the highlight to the card container instead of the grid item */
.grid-item .card-container.highlight-effect {
  box-shadow: 0 0 0 3px #4169e1, 0 4px 8px rgba(0,0,0,0.15) !important;
  transition: box-shadow 0.3s ease;
}

/* Media section styling */
.media-section {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Styles for the sticky rearrange section */
.rearrange-section.sticky {
  position: fixed;
  top: 60px;
  z-index: 100;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-height: 90vh;
  overflow-y: auto;
  transition: all 0.2s ease;
  margin: 0;
  /* Ensure width is maintained */
  right: auto;
  left: auto;
}

/* Only use this for mobile */
@media (max-width: 992px) {
  .rearrange-section.sticky {
    width: calc(100% - 30px) !important; /* Override JS width for mobile */
    left: 15px;
    right: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AddOrEditProduct.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,qCAAqC;AACrC;EACE,wCAAwC;EACxC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,uFAAuF;AACvF;EACE,oEAAoE;EACpE,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,+BAA+B;EAC/B,WAAW;EACX,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE;IACE,mCAAmC,EAAE,iCAAiC;IACtE,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":[".card-container {\n  max-width: 600px;\n  margin: 0px auto;\n  border-radius: 6px;\n  box-shadow: 0 0 41px 4px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  gap: 0rem;\n}\n\n.image-wrapper {\n  position: relative;\n  background-color: #000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.image-wrapper img {\n  width: 100%;\n  height: auto;\n  border-radius: 6px 6px 0 0;\n}\n\n.description-container {\n  color: #fff;\n  font-size: 18px;\n  line-height: 25px;\n  white-space: pre-wrap;\n}\n\n.description-editable {\n  cursor: text;\n  outline: 0;\n  word-wrap: break-word;\n  padding: 20px;\n  border-radius: 0px 0px 5px 5px;\n  min-height: 60px;\n}\n\n.description-editable:empty:before {\n  content: attr(placeholder);\n  color: #babec4;\n  pointer-events: none;\n}\n\n/* PayPal header with toggle styles */\n.paypal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.paypal-icon {\n  margin-right: 8px;\n  color: #003087;\n}\n\n.paypal-preview-container {\n  border-width: 2px;\n  font-size: 12px;\n}\n\n/* Image Preview Grid Layout */\n.image-number-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  width: 30px;\n  height: 30px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  z-index: 5;\n}\n\n.image-preview-section .card-container {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n  transition: transform 0.2s;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  max-width: none;\n  margin: 0;\n}\n\n.image-preview-section .card-container:hover {\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.image-preview-section .image-wrapper {\n  position: relative;\n  overflow: hidden;\n  flex: 1;\n  min-height: 200px;\n  background-color: #420120a7;\n}\n\n.image-preview-section .image-wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  border-radius: 0;\n}\n\n.image-preview-section .description-container {\n  background-color: #000000;\n  color: #ffffff;\n}\n\n/* Grid layout */\n.grid-container {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 20px;\n  width: 100%;\n}\n\n.grid-item {\n  width: 100%;\n}\n\n/* Responsive grid */\n@media (min-width: 576px) {\n  .grid-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 768px) {\n  .grid-container {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 992px) {\n  .grid-container {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* Sticky sidebar styles */\n.sticky-sidebar {\n  position: sticky;\n  top: 80px;\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n}\n\n/* Set image preview to single column */\n@media (min-width: 992px) {\n  .image-preview-section .grid-container {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  \n  .image-preview-section .card-container {\n    max-width: 100%;\n  }\n  \n  .image-preview-section .image-wrapper {\n    min-height: 350px;\n  }\n}\n\n/* Thumbnail click highlight effect */\n.highlight-effect {\n  box-shadow: 0 0 0 3px #4169e1 !important;\n  transition: box-shadow 0.3s ease;\n  border-radius: 6px;\n}\n\n/* Another approach: add the highlight to the card container instead of the grid item */\n.grid-item .card-container.highlight-effect {\n  box-shadow: 0 0 0 3px #4169e1, 0 4px 8px rgba(0,0,0,0.15) !important;\n  transition: box-shadow 0.3s ease;\n}\n\n/* Media section styling */\n.media-section {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Styles for the sticky rearrange section */\n.rearrange-section.sticky {\n  position: fixed;\n  top: 60px;\n  z-index: 100;\n  border-radius: 4px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-height: 90vh;\n  overflow-y: auto;\n  transition: all 0.2s ease;\n  margin: 0;\n  /* Ensure width is maintained */\n  right: auto;\n  left: auto;\n}\n\n/* Only use this for mobile */\n@media (max-width: 992px) {\n  .rearrange-section.sticky {\n    width: calc(100% - 30px) !important; /* Override JS width for mobile */\n    left: 15px;\n    right: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
